import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Subject } from "rxjs";
import { Locale } from "../hooks/Locale";
function toGtLang(locale) {
  var gtLang = "eng";
  if (locale === Locale.zhCN) {
    gtLang = "zho";
  } else if (locale === Locale.zhTW) {
    gtLang = "zho-tw";
  } else if (locale === Locale.ja) {
    gtLang = "jpn";
  } else if (locale === Locale.id) {
    gtLang = "ind";
  } else if (locale === Locale.ko) {
    gtLang = "kor";
  } else if (locale === Locale.ru) {
    gtLang = "rus";
  } else if (locale === Locale.ar) {
    gtLang = "ara";
  } else if (locale === Locale.fr) {
    gtLang = "fra";
  } else if (locale === Locale.de) {
    gtLang = "deu";
  }
  return gtLang;
}
export var GtCaptchaApi = /*#__PURE__*/function () {
  function GtCaptchaApi() {
    _classCallCheck(this, GtCaptchaApi);
    _defineProperty(this, "subject", new Subject());
    _defineProperty(this, "isReady", false);
  }
  _createClass(GtCaptchaApi, [{
    key: "verify",
    value: function verify(params) {
      return new Promise(function (resolve, reject) {
        var win = window;
        if (!(win !== null && win !== void 0 && win.initGeetest4)) {
          reject({
            code: -1,
            message: "GtCaptcha is not ready"
          });
        }
        var captchaId = params.captchaId,
          riskType = params.riskType,
          lang = params.lang;
        win.initGeetest4({
          captchaId: captchaId,
          riskType: riskType,
          product: "bind",
          language: toGtLang(lang),
          onError: function onError() {
            reject({
              code: -1,
              message: "GtCaptcha initGeetest4 error"
            });
          }
        }, function (captchaObj) {
          captchaObj.onSuccess(function () {
            var result = captchaObj.getValidate();
            resolve(result);
            captchaObj.destroy();
          }).onError(function (error) {
            reject(error);
          }).onClose(function () {
            reject({
              code: -10,
              message: "GtCaptcha cancel"
            });
            captchaObj.destroy();
          }).onReady(function () {
            captchaObj.showCaptcha();
          });
        });
      });
    }
  }, {
    key: "requestGtCaptcha",
    value: function requestGtCaptcha(params) {
      var _this = this;
      if (this.isReady) {
        return this.verify(params);
      }
      return new Promise(function (resolve, reject) {
        var scriptId = "gt-captcha-v4";
        if (!document.getElementById(scriptId)) {
          var script = document.createElement("script");
          script.id = scriptId;
          script.type = "text/javascript";
          script.async = true;
          script.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var token;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _this.isReady = true;
                  _this.subject.next(scriptId);
                  _context.prev = 2;
                  _context.next = 5;
                  return _this.verify(params);
                case 5:
                  token = _context.sent;
                  resolve(token);
                  _context.next = 12;
                  break;
                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](2);
                  reject(_context.t0);
                case 12:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[2, 9]]);
          }));
          script.onerror = function (event, source, lineno, colno, error) {
            reject(error);
            var scr = document.getElementById(scriptId);
            if (scr) {
              var _scr$parentNode;
              (_scr$parentNode = scr.parentNode) === null || _scr$parentNode === void 0 ? void 0 : _scr$parentNode.removeChild(scr);
            }
          };
          script.src = "https://static.geetest.com/v4/gt4.js";
          var head = document.getElementsByTagName("head")[0];
          head.appendChild(script);
        } else {
          _this.subject.subscribe( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var token;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return _this.verify(params);
                case 3:
                  token = _context2.sent;
                  resolve(token);
                  _context2.next = 10;
                  break;
                case 7:
                  _context2.prev = 7;
                  _context2.t0 = _context2["catch"](0);
                  reject(_context2.t0);
                case 10:
                case "end":
                  return _context2.stop();
              }
            }, _callee2, null, [[0, 7]]);
          })));
        }
      });
    }
  }]);
  return GtCaptchaApi;
}();
_defineProperty(GtCaptchaApi, "shared", new GtCaptchaApi());